if (window.innerWidth <= 768) {
  jQuery(function () {
    jQuery("li.nav_solutions_we_love.menu-item-has-children > a").click(function (event) {
      // Vérifie si l'élément cliqué est directement cet élément, et non un enfant
      if (event.target === this) {
        jQuery("li.nav_solutions_we_love.menu-item-has-children").toggleClass("resp_this_hover");
      }
    });
  });
}